(function () {
    const miniCart = document.querySelector('[data-mini-cart]');
    const triggers = document.querySelectorAll('[data-mini-cart-trigger]');
    const closeButton = miniCart ? miniCart.querySelector('.mini-cart__close') : null;
    const body = document.body;

    if (!miniCart || !triggers.length) return;

    let isOpen = false;
    let closeTimer = null;
    let lastTrigger = null;

    function syncExpanded(nextValue) {
        triggers.forEach(trigger => {
            trigger.setAttribute('aria-expanded', String(nextValue));
        });
    }

    async function refreshMiniCartContent() {
        try {
            const response = await fetch('/?sections=mini-cart');
            if (!response.ok) return;

            const data = await response.json();
            const newHtml = data['mini-cart'];

            if (newHtml) {
                const temp = document.createElement('div');
                temp.innerHTML = newHtml;
                const newMiniCart = temp.querySelector('[data-mini-cart]');

                if (newMiniCart) {
                    miniCart.innerHTML = newMiniCart.innerHTML;
                }

                // Update the cart count badge in the header trigger
                const cartCountMatch = newHtml.match(/\((\d+)\s/);
                if (cartCountMatch) {
                    const newCount = cartCountMatch[1];
                    let badge = document.querySelector('[data-mini-cart-trigger] sup');
                    if (newCount > 0) {
                        if (!badge) {
                            const trigger = document.querySelector('[data-mini-cart-trigger]');
                            if (trigger) {
                                badge = document.createElement('sup');
                                trigger.prepend(badge);
                            }
                        }
                        if (badge) {
                            badge.textContent = newCount;
                        }
                    } else {
                        if (badge) {
                            badge.remove();
                        }
                    }
                }
            }
        } catch (error) {
            console.error('Failed to refresh mini cart:', error);
        }
    }

    async function openMiniCart(trigger) {
        if (closeTimer) {
            window.clearTimeout(closeTimer);
            closeTimer = null;
        }

        lastTrigger = trigger;

        await refreshMiniCartContent();

        body.classList.add('mini-cart-open');
        syncExpanded(true);
        isOpen = true;

        if (closeButton) {
            closeButton.focus();
        }
    }

    function closeMiniCart() {
        if (!isOpen) return;

        body.classList.remove('mini-cart-open');
        syncExpanded(false);
        isOpen = false;

        closeTimer = window.setTimeout(() => {
            if (!isOpen) {
                body.classList.remove('mini-cart-open');
            }

            if (lastTrigger && typeof lastTrigger.focus === 'function') {
                lastTrigger.focus();
            }
        }, 300);
    }

    triggers.forEach(trigger => {
        trigger.addEventListener('click', event => {
            event.preventDefault();

            if (isOpen) {
                closeMiniCart();
                return;
            }

            openMiniCart(trigger);
        });
    });

    const debounceDelay = 600;
    let debounceTimer = null;
    let optimisticQuantities = {}; // Bộ nhớ tạm để gom số lượng khi click liên tục
    let quantityChangeInProgress = false; // Cờ để kiểm tra xem có đang thay đổi số lượng hay không

    function handleRemoveItem(itemKey, removeBtn) {
        if (itemKey) {
            removeBtn.disabled = true;
            miniCart.classList.add('mini-cart--loading');
            fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                },
                body: JSON.stringify({ id: itemKey, quantity: 0 }),
            })
                .then(response => {
                    if (!response.ok) throw new Error('Remove item failed');
                    return refreshMiniCartContent();
                })
                .catch(error => console.error(error))
                .finally(() => {
                    miniCart.classList.remove('mini-cart--loading');
                    removeBtn.disabled = false;
                });
        }
    }

    // Use event delegation for interactive elements since the drawer content is refreshed
    miniCart.addEventListener('click', event => {
        const closeBtn = event.target.closest('[data-mini-cart-close]');
        if (closeBtn) {
            closeMiniCart();
            return;
        }

        // Handle remove item
        const removeBtn = event.target.closest('[data-remove-item]');
        if (removeBtn) {
            const itemKey = removeBtn.dataset.itemKey;
            if (itemKey) {
                removeBtn.disabled = true;
                // add class loading to mini cart to show loading state
                miniCart.classList.add('mini-cart--loading');
                fetch('/cart/change.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                    },
                    body: JSON.stringify({ id: itemKey, quantity: 0 }),
                })
                    .then(response => {
                        if (!response.ok) throw new Error('Remove item failed');
                        return refreshMiniCartContent();
                    })
                    .catch(error => console.error(error))
                    .finally(() => {
                        miniCart.classList.remove('mini-cart--loading');
                        removeBtn.disabled = false;
                    });
            }
            return;
        }

        const qtyBtn = event.target.closest('[data-qty-change]');
        if (qtyBtn) {
            event.preventDefault();

            const itemKey = qtyBtn.dataset.itemKey;
            const change = qtyBtn.dataset.qtyChange;

            if (itemKey && (change === 'minus' || change === 'plus')) {
                const quantityEl = qtyBtn
                    .closest('.cart-item__quantity-selector')
                    ?.querySelector('[data-item-quantity]');
                if (!quantityEl) return;

                // add class loading to mini cart to show loading state

                // Đọc số lượng thực tế trong DOM tại thời điểm click đầu tiên
                const currentDOMQty = parseInt(quantityEl.textContent, 10);

                // Sửa Lỗi 3: Nếu chưa có trong bộ nhớ tạm, lấy số từ DOM. Nếu có rồi, lấy số đang thay đổi dở dang
                if (optimisticQuantities[itemKey] === undefined) {
                    optimisticQuantities[itemKey] = currentDOMQty;
                }

                // Tính toán số lượng mới dựa trên bộ nhớ tạm
                const currentOptimisticQty = optimisticQuantities[itemKey];
                const newQty =
                    change === 'plus'
                        ? currentOptimisticQty + 1
                        : Math.max(1, currentOptimisticQty - 1);

                // Cập nhật lại bộ nhớ tạm
                optimisticQuantities[itemKey] = newQty;

                // Sửa Lỗi 2: Cập nhật UI ngay lập tức bên NGOÀI setTimeout để giao diện mượt mà
                quantityEl.textContent = String(newQty);

                // Xóa bộ hẹn giờ cũ nếu khách hàng vẫn đang click liên tục
                if (debounceTimer) clearTimeout(debounceTimer);

                // Chạy debounce cho việc gửi API
                debounceTimer = setTimeout(() => {
                    const finalQty = optimisticQuantities[itemKey];
                    miniCart.classList.add('mini-cart--loading');

                    fetch('/cart/change.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            Accept: 'application/json',
                        },
                        body: JSON.stringify({ id: itemKey, quantity: finalQty }),
                    })
                        .then(response => {
                            // get message from response if not ok
                            if(!response.ok) {
                                return response.json().then(data => {
                                    const errorMessage = data.description || 'Change quantity failed';
                                    window.Toast.show({
                                        message: errorMessage,
                                        type: 'error',
                                    });
                                    handleRemoveItem(itemKey, qtyBtn); // remove item if change quantity failed
                                    // alert(errorMessage);
                                    throw new Error(errorMessage);
                                });
                            }
                            return refreshMiniCartContent();
                        })
                        .then(() => {
                            // Thành công: xóa bộ nhớ tạm của item này
                            delete optimisticQuantities[itemKey];
                        })
                        .catch(error => {
                            // Thất bại: Rollback giao diện về số lượng thực tế ban đầu trước khi chuỗi click diễn ra
                            quantityEl.textContent = String(currentDOMQty);
                            delete optimisticQuantities[itemKey];
                            console.error(error);
                        })
                        .finally(() => {
                            miniCart.classList.remove('mini-cart--loading');
                        });
                }, debounceDelay);
            }
            return;
        }
        // Handle quantity change (minus/plus)
    });

    document.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
            closeMiniCart();
        }
    });

    document.addEventListener('mini-cart:open', () => {
        if (isOpen) return;
        openMiniCart(triggers[0]);
    });
})();
